import { render } from "./ActionGroup.vue?vue&type=template&id=70dc06ee&scoped=true"
import script from "./ActionGroup.vue?vue&type=script&lang=js"
export * from "./ActionGroup.vue?vue&type=script&lang=js"

import "./ActionGroup.vue?vue&type=style&index=0&id=70dc06ee&scoped=true&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dc06ee"]])

export default __exports__